<mat-toolbar color="primary">
  <span>powered by <i>GP2 Applications GmbH</i></span>
  <span class="spacer"></span>
  <span (click)="countClick()">Pegasus Time | {{ version$ | async }}</span>
</mat-toolbar>
